var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({ref:"input",style:(_vm.style[_vm.size]),attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.inputChange}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }